import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const SvgIcon = (props: SvgIconT.Props) => {
  const { containerProps = {}, size, color, className = '', style = {}, innerRef, ...rest } = props;
  const fill = !color && !props.fill ? '#FFF' : props.fill;
  const width = !size && !props.width ? 24 : props.width;
  const height = !size && !props.height ? 24 : props.height;
  const { cssClassName } = convertPropToCssClassName('icon', className, {
    size,
    color,
  });
  return (
    <span
      ref={innerRef}
      className={cssClassName}
      {...rest}
      {...containerProps}
      style={{
        width,
        height,
        ...style,
      }}
    >
      <svg
        width={width && String(width)}
        height={height && String(height)}
        style={{
          width,
          height,
        }}
        fill={fill}
        viewBox="0 0 24 24"
      >
        <path
          d="M9.826875 17.7825c-.148125 0-.298125.016875-.45.0525-1.04625.2476875-1.696875 1.30125-1.449375 2.3475.2475 1.04625 1.30125 1.6970625 2.3475 1.449375.50625-.1198125.9375-.43125 1.21125-.87375.27375-.444375.358125-.9675.238125-1.47375-.211875-.89625-1.014375-1.501875-1.8975-1.501875zM20.8575 16.41375c-.3525.084375-.706875.12375-1.05375.12375-1.985625 0-3.7933125-1.305-4.38-3.264375H4.561875L0 22.39875V24h8.188125C6.825 23.475 5.73375 22.3125 5.37375 20.788125c-.58125-2.454375.943125-4.925625 3.3975-5.506875 2.45625-.5810625 4.925625.943125 5.506875 3.3975.28125 1.18875.0825 2.416875-.55875 3.4575-.5325.864375-1.321875 1.5075-2.25375 1.86375H24V13.779375c-.555 1.27875-1.685625 2.289375-3.1425 2.634375zM5.445 2.955C5.844375 1.63125 6.8325.519375 8.173125 0H0v2.955h5.445zm2.4825 1.760625C8.175 5.761875 9.22875 6.4125 10.275 6.165c.50625-.12.9375-.43125 1.21125-.87375.27375-.4425.358125-.9675.238125-1.47375-.12-.50625-.429375-.9375-.87375-1.21125-.31125-.193125-.66375-.290625-1.02-.290625-.15 0-.301875.016875-.45375.0525-1.04625.2475-1.696875 1.30125-1.449375 2.3475zm4.30125-4.3425c1.0404375.64125 1.768125 1.65 2.049375 2.840625.28125 1.18875.0825 2.416875-.55875 3.4575s-1.65 1.768125-2.840625 2.049375c-.3525.084375-.706875.12375-1.05375.12375-1.985625 0-3.793125-1.305-4.38-3.264375H0v10.95l2.94-5.88h12.481875c.455625-1.513125 1.681875-2.750625 3.32625-3.140625 1.18875-.28125 2.416875-.0825 3.4575.55875.81.49875 1.426875 1.2225 1.794375 2.079375V0H11.47875c.25875.10125.51.225.75.373125zm8.59875 9.928125c-.31125-.193125-.66375-.290625-1.0201875-.290625-.1498125 0-.3016875.016875-.4535625.0525-1.0464375.2475-1.696875 1.30125-1.449375 2.3476875.2473125 1.0460625 1.30125 1.695 2.3475 1.4491875.50625-.12.9375-.43125 1.21125-.87375.27375-.444375.358125-.9675.238125-1.47375-.1201875-.50625-.43125-.9375-.87375-1.21125z"
          fill="#FFF"
          fillRule="evenodd"
        />
      </svg>
    </span>
  );
};

export default SvgIcon;
